import { Component, forwardRef } from "react";
import { createPortal } from "react-dom";
import Loader from "../../../utils/Loader";
import { ToastContainer, toast } from "react-toastify";
import Pagination from "../../../utils/pagination";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../actions/fillCombo_action";
import Select from "react-select";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import VendorDrawer from "../../../common_components/vendor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import {
  exhibitionId,
  orderStatusActionId,
  serviceTypeId, vendorColumnConfigurationActionId,
  countryActionId,
  exhibitorTypeActionId,
  boothTypeActionId,
  toastError,
  toastSuccess,
} from "../../../utils/constants";
import {
  getVendorExhibitionList_action,
  markOrderSeen_action,
  getVendorExhibitorList_action,
} from "../../../actions/vendor_module_action/vendor_exhibition_list_action/vendor_exhibition_list_action";
import {
  raiseManualForm_action,
  markManualFormInvoicePaid_action,
} from "../../../actions/vendor_module_action/vendor_order_action";
import moment from "moment";
import Modal from "react-modal";
import Resizer from "react-image-file-resizer";
import ImageCapture from "../../../utils/ImageCapture";

//Manual Page
import FasciaForm from "../../exhibitor_module/manual_forms/forms/fascia_Form/fascia_form";
import ExhibitorBadge from "../../exhibitor_module/manual_forms/forms/exhibitor_badge_form/exhibitor_badge";
import ExhibitorDetails from "../../exhibitor_module/manual_forms/forms/exhibitor_details_form/exhibitor_details";
import VisaApplication from "../../exhibitor_module/manual_forms/forms/invitationVisaApplication/invitationVisaApplicationList";
import EDirectoryList from "../../exhibitor_module/manual_forms/forms/e-direcory_form/e-directory_list";
import KeywordsInformation from "../../exhibitor_module/manual_forms/forms/keywords_information_form/keywords_information";
import StallDesign from "../../exhibitor_module/manual_forms/forms/stallDesign/stallDesign";
import AdditionalFurniture from "../../exhibitor_module/manual_forms/forms/additional furniture/additional_furniture";
import StallPossession from "../../exhibitor_module/manual_forms/forms/stall_possesion/stall_possesion";
import PowerConnection from "../../exhibitor_module/manual_forms/forms/power_connection_form/power_connection";
import FreightForward from "../../exhibitor_module/manual_forms/forms/freight_forward/freight_forward";
import Water from "../../exhibitor_module/manual_forms/forms/water_form/water";
import AirConnectionApplication from "../../exhibitor_module/manual_forms/forms/airConnectionApplication/airConnectionApplication";
import CarPassesApplication from "../../exhibitor_module/manual_forms/forms/car_passes_application/car_passes_application";
import LiquareLicense from "../../exhibitor_module/manual_forms/forms/liquare_license/liquare_license";
import LeadRetrievalConnectionApplication from "../../exhibitor_module/manual_forms/forms/leadRetrievalConnectionApplication/leadRetrievalConnectionApplication";
import MeetingRoomRequestForm from "../../exhibitor_module/manual_forms/forms/Meeting room request form/MeetingRoomRequestForm";
import DelegateMeeting from "../../exhibitor_module/manual_forms/forms/delegate_meeting/delegate_meeting";
import VisitorMeetingApplication from "../../exhibitor_module/manual_forms/forms/visitor_meeting_application/visitor_meeting_application";
import InternetConnection from "../../exhibitor_module/manual_forms/forms/internet_connection/internet_connection";
import HousekeepingConnection from "../../exhibitor_module/manual_forms/forms/housekeeping_connection/housekeeping_connection";
import SecurityApplication from "../../exhibitor_module/manual_forms/forms/security_application/security_application";
import CateringServices from "../../exhibitor_module/manual_forms/forms/catering_services/catering_services";
import HostHostessRequirements from "../../exhibitor_module/manual_forms/forms/host_hostess_requirement/host_hostess_requirement";
import BrandingOpportunityAndAdvertisement from "../../exhibitor_module/manual_forms/forms/brandingApportunityAndAdvertisement/brandingApportunityAndAdvertisement";
import RentalAudioAndVideoEquipment from "../../exhibitor_module/manual_forms/forms/rentalAudioAndVedioEquipment/rentalAudioAndVedioEquipment";
import ExhibitorContractorBadgeApplication from "../../exhibitor_module/manual_forms/forms/exhibitor_contractor_badgeApplication/exhibitor_contractor_badgeApplication";
import PlantAndBeautification from "../../exhibitor_module/manual_forms/forms/PlantAndBeautification/PlantAndBeautification";
import RentalAudioAndVedioEquipment from "../../exhibitor_module/manual_forms/forms/rentalAudioAndVedioEquipment/rentalAudioAndVedioEquipment";
import CommonModal from "../../../utils/CommonModal";

const styles = {
  width: "100%",
};


class VendorExhibitorList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      vendorRegistrationList: [],
      vendorServiceList: [],
      currentPage: 1,
      ExhibitionID: "",
      exhibitionList: [],
      ServiceID: "",
      StatusID: "",
      serviceTypeList: [],
      orderStatusList: [],
      showRaiseModal: false,
      showMarkPaidModal: false,
      selectedRecord: null,
      selectedFile: null,
      useCamera: false,
      documentFile: { FileName: "", FilePath: "", FileType: "" },
      showVideoModal: false,
      dashboardData: null,
      showCameraModal: false,
      //modal
      isManualFormModalOpen: false,
      selectedServiceName: null,
      isCompanyModalOpen: false,
      ExhRegistrationFilter: "",
      CompanyNameFilter: "",
      PersonNameFilter: "",
      countryList: [],
      CountryIDs: [],
      exhibitorTypeList: [],
      ExhibitorTypeID: "",
      boothTypeList: [],
      BoothTypeID: "",
      appliedExhRegistrationFilter: "",
      appliedCompanyNameFilter: "",
      appliedPersonNameFilter: "",
      appliedCountryIDs: [],
      appliedExhibitorTypeID: "",
      appliedBoothTypeID: "",
      isViewModalOpen: false,
      selectedId: '',
      selectedServiceId: '',
      vendorColumnConfigurationList: []
    };
    this.loadingCount = 0;
    this.updateItem = this.updateItem.bind(this);
    this.onViewClick = this.onViewClick.bind(this);
  }

  // Keep the loader visible as long as any request is still in flight
  startLoading = () => {
    this.loadingCount += 1;
    if (!this.state.isLoading) {
      this.setState({ isLoading: true });
    }
  };

  stopLoading = () => {
    this.loadingCount = Math.max(0, this.loadingCount - 1);
    if (this.loadingCount === 0) {
      this.setState({ isLoading: false });
    }
  };

  componentDidMount() {
    this.getFillList(exhibitionId, "", "", "", "", "");
    this.getFillList(serviceTypeId, "", "", "", "", "");
    this.getFillList(orderStatusActionId, "", "", "", "", "");
    this.getFillList(countryActionId, "", "", "", "", "");
    this.getFillList(exhibitorTypeActionId, "", "", "", "", "");
    this.getFillList(boothTypeActionId, "", "", "", "", "");
    this.getFillList(vendorColumnConfigurationActionId, sessionStorage.getItem("sessionExhibitionID"), "", "", "", "");

    // Auto-set exhibition for vendor role (RoleID 7)
    const loginData = JSON.parse(sessionStorage.getItem("loginDataSS"));
    const filterStatusID = sessionStorage.getItem("filterStatusID");
    const filterServiceName = sessionStorage.getItem("filterServiceName");

    if (loginData && (loginData.RoleID === 7 || loginData.RoleID === 17)) {
      const exhibitionID = sessionStorage.getItem("sessionExhibitionID");
      if (exhibitionID) {
        this.setState(
          {
            ExhibitionID: exhibitionID,
            StatusID: filterStatusID || "",
          },
          () => {
            if (filterServiceName) {
              this.startLoading();
              setTimeout(() => {
                const matchedService = this.state.serviceTypeList.find(
                  (s) => s.Name === filterServiceName,
                );
                if (matchedService) {
                  this.setState({ ServiceID: matchedService.ServiceID }, () => {
                    this.stopLoading();
                    this.getVendorExhibitorList();
                  });
                } else {
                  this.stopLoading();
                  this.getVendorExhibitorList();
                }
              }, 500);
            } else {
              this.getVendorExhibitorList();
            }
            sessionStorage.removeItem("filterStatusID");
            sessionStorage.removeItem("filterServiceName");
          },
        );
      } else {
        this.setState(
          {
            StatusID: filterStatusID || "",
          },
          () => {
            if (filterServiceName) {
              this.startLoading();
              setTimeout(() => {
                const matchedService = this.state.serviceTypeList.find(
                  (s) => s.Name === filterServiceName,
                );
                if (matchedService) {
                  this.setState({ ServiceID: matchedService.ServiceID }, () => {
                    this.stopLoading();
                    this.getVendorExhibitorList();
                  });
                } else {
                  this.stopLoading();
                  this.getVendorExhibitorList();
                }
              }, 500);
            } else {
              this.getVendorExhibitorList();
            }
            sessionStorage.removeItem("filterStatusID");
            sessionStorage.removeItem("filterServiceName");
          },
        );
      }
    } else {
      this.setState(
        {
          StatusID: filterStatusID || "",
        },
        () => {
          if (filterServiceName) {
            setTimeout(() => {
              const matchedService = this.state.serviceTypeList.find(
                (s) => s.Name === filterServiceName,
              );
              if (matchedService) {
                this.setState({ ServiceID: matchedService.ServiceID }, () => {
                  this.getVendorExhibitorList();
                });
              } else {
                this.getVendorExhibitorList();
              }
            }, 500);
          } else {
            this.getVendorExhibitorList();
          }
          sessionStorage.removeItem("filterStatusID");
          sessionStorage.removeItem("filterServiceName");
        },
      );
    }
  }
  openModal(ServiceName) {
    if (ServiceName === "Fascia") {
      return <FasciaForm />;
    } else if ((ServiceName || "").trim() === "Exhibitor Paid Badges") {
      return <ExhibitorBadge />;
    } else if ((ServiceName || "").trim() === "exhibitorDetails") {
      return <ExhibitorDetails />;
    } else if ((ServiceName || "").trim() === "Visa Application  ") {
      return <VisaApplication />;
    } else if ((ServiceName || "").trim() === "edirectoryList") {
      return <EDirectoryList />;
    } else if ((ServiceName || "").trim() === "Keywords") {
      return <KeywordsInformation />;
    } else if ((ServiceName || "").trim() === "Stall Design") {
      return <StallDesign />;
    } else if ((ServiceName || "").trim() === "Furniture") {
      return <AdditionalFurniture />;
    } else if ((ServiceName || "").trim() === "Stall Possession") {
      return <StallPossession />;
    } else if ((ServiceName || "").trim() === "Power") {
      return <PowerConnection />;
    } else if ((ServiceName || "").trim() === "Freight Forwarders") {
      return <FreightForward />;
    } else if ((ServiceName || "").trim() === "Water") {
      return <Water />;
    } else if ((ServiceName || "").trim() === "Air") {
      return <AirConnectionApplication />;
    } else if ((ServiceName || "").trim() === "Car Passes") {
      return <CarPassesApplication />;
    } else if (ServiceName === "Liquor License") {
      return <LiquareLicense />;
    } else if ((ServiceName || "").trim() === "Lead Retrieval") {
      return <LeadRetrievalConnectionApplication />;
    } else if ((ServiceName || "").trim() === "Meeting Room") {
      return <MeetingRoomRequestForm />;
    } else if ((ServiceName || "").trim() === "delegateMeeting") {
      return <DelegateMeeting />;
    } else if ((ServiceName || "").trim() === "visitorMeetingApplication") {
      return <VisitorMeetingApplication />;
    } else if ((ServiceName || "").trim() === "Internet Connection") {
      return <InternetConnection />;
    } else if ((ServiceName || "").trim() === "Housekeeping") {
      return <HousekeepingConnection />;
    } else if ((ServiceName || "").trim() === "Security") {
      return <SecurityApplication />;
    } else if ((ServiceName || "").trim() === "Catering") {
      return <CateringServices />;
    } else if ((ServiceName || "").trim() === "Host and Hostess") {
      return <HostHostessRequirements />;
    } else if ((ServiceName || "").trim() === "Branding Opportunity") {
      return <BrandingOpportunityAndAdvertisement />;
    } else if ((ServiceName || "").trim() === "AV Equipments") {
      return <RentalAudioAndVideoEquipment />;
    } else if ((ServiceName || "").trim() === "Contractor Badge") {
      return <ExhibitorContractorBadgeApplication />;
    } else if ((ServiceName || "").trim() === "plantAndBeautification") {
      return <PlantAndBeautification />;
    } else {
      return null; // or <NotFound />
    }
  }
  handleManualFormModal = (serviceName, ExhRegistrationID) => {
    sessionStorage.setItem("ExhRegistrationIDSS", ExhRegistrationID);
    this.setState({
      isManualFormModalOpen: true,
      selectedServiceName: serviceName,
    });
  };

  handleCompanyModal = (data) => {
    sessionStorage.setItem("ExhRegistrationIDSS", data.ExhRegistrationID);
    this.setState({
      isCompanyModalOpen: true,
      selectedCompanyData: data,
    });
  };

  // get fill List dropdown
  getFillList(
    actionID,
    exhibitionID,
    moduleID,
    keyValue,
    value,
    exhRegistrationID,
  ) {
    this.startLoading();
    this.props
      .fill_action(
        actionID,
        exhibitionID,
        moduleID,
        keyValue,
        value,
        exhRegistrationID,
      )
      .then((data) => {
        if (data.error != 1) {
          // voucher list
          if (actionID === exhibitionId) {
            // console.log("voucher type data", data.data)
            this.setState({
              exhibitionList: data.data,
            });
          }
          if (actionID === serviceTypeId) {
            console.log("voucher type data", data.data);
            var sessionServiceList = sessionStorage.getItem("serviceids") ? JSON.parse(sessionStorage.getItem("serviceids")) : []
            const serviceIds = sessionServiceList.length > 0 ? new Set(sessionServiceList.map(item => item.ServiceId)) : null
            const filteredServices = serviceIds != null ? data.data.filter(item =>
              serviceIds.has(item.ServiceID)
            ) : []

            this.setState({
              selectedServiceId: filteredServices.length > 0 ? filteredServices[0].ServiceID : '',
              serviceTypeList: filteredServices,
            });
          }
          if (actionID === orderStatusActionId) {
            this.setState({
              orderStatusList: data.data,
            });
          }
          if (actionID === countryActionId) {
            this.setState({
              countryList: data.data,
            });
          }
          if (actionID === exhibitorTypeActionId) {
            this.setState({
              exhibitorTypeList: data.data,
            });
          }
          if (actionID === boothTypeActionId) {
            this.setState({
              boothTypeList: data.data,
            });
          }
        } else {
          toastError(data.msg);
        }
        this.stopLoading();
      })
      .catch((e) => {
        console.log(e);
        this.stopLoading();
      });
  }

  // Update Current Page
  updateItem(item) {
    const { vendorRegistrationList } = this.state;
    this.setState({ currentPage: item });
    const recordsPerPage = 10;
    const indexOfLastRecord = item * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = Array.isArray(vendorRegistrationList)
      ? vendorRegistrationList.slice(indexOfFirstRecord, indexOfLastRecord)
      : [];
    const nPages = Math.ceil(
      (vendorRegistrationList?.length || 0) / recordsPerPage,
    );
  }

  getVendorExhibitionList() {
    const { ExhibitionID, ServiceID, StatusID } = this.state;
    const filterStatusID = sessionStorage.getItem("filterStatusID");
    this.startLoading();
    this.props
      .getVendorExhibitionList_action(ExhibitionID, ServiceID, StatusID)
      .then((data) => {
        if (data.error != 1) {
          console.log("API Response data.data:", data.data);
          this.setState(
            {
              vendorRegistrationList: data.data.exhibitorList,
              vendorServiceList: data.data.serviceList,
              dashboardData: data.data,
            },
            () => {
              console.log("Updated dashboardData:", this.state.dashboardData);
            },
          );

          if (filterStatusID === "3" && data.data.exhibitorList?.length > 0) {
            const exhibitionID = sessionStorage.getItem("sessionExhibitionID");
            const vendorID = sessionStorage.getItem("AccountIDSS");
            const orderDetails = data.data.exhibitorList.map((item) => ({
              ExhibitionID: exhibitionID,
              VendorID: vendorID,
              ExhRegistrationID: item.ExhRegistrationID,
              ServiceID: item.ServiceID,
            }));
            this.props.markOrderSeen_action(orderDetails);
          }
        } else {
          toastError(data.msg);
        }
        this.stopLoading();
      })
      .catch((err) => {
        console.log(err);
        this.stopLoading();
      });
  }

  getVendorExhibitorList() {
    const { ExhibitionID, selectedServiceId } = this.state;
    const VendorID = sessionStorage.getItem("AccountIDSS") || "";
    this.startLoading();
    var sessionServiceList = sessionStorage.getItem("serviceids") ? JSON.parse(sessionStorage.getItem("serviceids")) : []
    this.props
      .getVendorExhibitorList_action(ExhibitionID, VendorID, selectedServiceId ? selectedServiceId : sessionServiceList.length > 0 ? sessionServiceList[0].ServiceId : '')
      .then((data) => {
        if (data.error != 1) {
          console.log("getVendorExhibitorList API Response:", data.data);
          // Fix: API returns vendorExhibitorList, not exhibitorList
          const rawExhibitorList =
            data.data?.vendorExhibitorList ||
            data.data?.exhibitorList ||
            data.data ||
            [];
          const exhibitorList = this.normalizeExhibitorList(rawExhibitorList);
          var service = selectedServiceId ? selectedServiceId : sessionServiceList.length > 0 ? sessionServiceList[0].ServiceId : ''
          const serviceList = data.data?.serviceList || [];
          var colToDisplaytemp = data.data?.columnsToDisplay || [];
          var colToDisplayMain = [];
          if (service != '') {
            colToDisplaytemp.length > 0 && colToDisplaytemp.map(item => {
              if (item.ServiceID == service) {
                colToDisplayMain.push(item.ColumnID)
              }
            })
          }
          // No column configuration for this service -> show all columns
          if (colToDisplayMain.length === 0) {
            colToDisplayMain = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
          }
          this.setState({
            vendorColumnConfigurationList: colToDisplayMain,
            vendorRegistrationList: Array.isArray(exhibitorList)
              ? exhibitorList
              : [],
            vendorServiceList: serviceList,
            dashboardData: data.data,
          });
        } else {
          toastError(data.msg);
        }
        this.stopLoading();
      })
      .catch((err) => {
        console.log(err);
        this.stopLoading();
      });
  }

  // Clean up SP response: StallTypeID comes as [1, 1] (selected twice), text fields
  // have trailing spaces, and the StallDesignFormHdr join can repeat an exhibitor
  normalizeExhibitorList(list) {
    if (!Array.isArray(list)) return [];
    const trim = (v) => (typeof v === "string" ? v.trim() : v);
    const byRegistration = new Map();
    list.forEach((item) => {
      const record = {
        ...item,
        StallTypeID: Array.isArray(item.StallTypeID) ? item.StallTypeID[0] : item.StallTypeID,
        CompanyName: trim(item.CompanyName),
        name: trim(item.name),
        CountryName: trim(item.CountryName),
        StateName: trim(item.StateName),
        CityName: trim(item.CityName),
      };
      const existing = byRegistration.get(record.ExhRegistrationID);
      if (!existing) {
        byRegistration.set(record.ExhRegistrationID, record);
      } else if (record.isStallDesignApproved && !existing.isStallDesignApproved) {
        // Prefer the row with an approved stall design
        byRegistration.set(record.ExhRegistrationID, record);
      }
    });
    return Array.from(byRegistration.values());
  }

  clearValue() {
    const loginData = JSON.parse(sessionStorage.getItem("loginDataSS"));
    if (loginData && (loginData.RoleID === 7 || loginData.RoleID === 17)) {
      // For vendors, don't clear ExhibitionID, only ServiceID and StatusID
      this.setState({ ServiceID: "", StatusID: "" });
    } else {
      this.setState({ ExhibitionID: "", ServiceID: "", StatusID: "" });
    }

    setTimeout(() => {
      this.getVendorExhibitorList();
    }, 100);
  }

  onViewClick(exhRegId, ServiceID) {
    const { CompanyName } = this.state;
    sessionStorage.setItem("ExhRegistrationIDSS", exhRegId);
    if (ServiceID == 3) {
      this.props.navigate("/powerConnection", {
        state: { is_View: true, from: "vendor" },
      });
    } else if (ServiceID == 4) {
      this.props.navigate("/water", {
        state: { is_View: true, from: "vendor" },
      });
    } else if (ServiceID == 5) {
      this.props.navigate("/airConnectionApplication", {
        state: { is_View: true, from: "vendor" },
      });
    } else if (ServiceID == 6) {
      this.props.navigate("/meetingRoomRequestForm", {
        state: { is_View: true, from: "vendor" },
      });
    } else if (ServiceID == 9) {
      this.props.navigate("/exhibitorbadgeAU", {
        state: { is_View: true, from: "vendor" },
      });
    } else if (ServiceID == 10) {
      this.props.navigate("/stallDesign", {
        state: { is_View: true, from: "vendor" },
      });
    } else if (ServiceID == 21) {
      this.props.navigate("/freightForward", {
        state: { is_View: true, from: "vendor" },
      });
    }
  }

  openRaiseModal = (record) => {
    this.setState({
      showRaiseModal: true,
      selectedRecord: record,
      selectedFile: null,
      useCamera: false,
      documentFile: { FileName: "", FilePath: "", FileType: "" },
    });
  };

  openMarkPaidModal = (record) => {
    this.setState({ showMarkPaidModal: true, selectedRecord: record });
  };

  closeModals = () => {
    this.setState({
      showRaiseModal: false,
      showMarkPaidModal: false,
      selectedRecord: null,
      selectedFile: null,
      useCamera: false,
      documentFile: { FileName: "", FilePath: "", FileType: "" },
      showCameraModal: false,
    });
  };

  handleFileSelect = (e) => {
    this.setState({ selectedFile: e.target.files[0] });
  };

  async handleDocumentInput(e, fieldName) {
    if (fieldName === "file") {
      const result = await this.onFilePick(e, e.target.files);
      if (result) {
        this.setState({
          documentFile: {
            FilePath: result.FilePath,
            FileName: result.FileName,
            FileType: result.FileType,
          },
        });
      }
    } else if (fieldName === "clear") {
      this.setState({
        documentFile: { FileName: "", FilePath: "", FileType: "" },
      });
    }
  }

  onFilePick = async (e, file) => {
    e.preventDefault();
    var image = "";
    if (file[0]["size"] > 3145728) {
      toast.error("File size more than 3MB are not allow.", {
        position: "top-center",
        theme: "colored",
        autoClose: 3000,
        hideProgressBar: true,
      });
      return null;
    } else {
      if (
        file[0]["name"].toString().toLowerCase().includes(".pdf") ||
        file[0]["name"].toString().toLowerCase().includes(".jpeg") ||
        file[0]["name"].toString().toLowerCase().includes(".png") ||
        file[0]["name"].toString().toLowerCase().includes(".jpg")
      ) {
        if (file[0]["name"].includes("pdf")) {
          image = await this.onPdfSelect(file[0]);
        } else {
          image = await this.resizeFile(file[0]);
        }

        const fileType = file[0]["type"];
        var fileTypeList;
        if (fileType.includes("/")) {
          fileTypeList = fileType.split("/");
        }
        const finalFileTypeName =
          fileTypeList.length > 0 ? fileTypeList[1] : "";

        return {
          FilePath: image,
          FileName: file[0]["name"],
          FileType: finalFileTypeName,
        };
      } else {
        toast.error("Only .pdf, .jpeg, .png, files are allowed", {
          position: "top-center",
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
        return null;
      }
    }
  };

  onPdfSelect = (file) =>
    new Promise((resolve) => {
      let base64;
      let fileReader = new FileReader();
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result;
        resolve(base64);
      };
      fileReader.readAsDataURL(file);
    });

  resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        500,
        600,
        "JPEG",
        80,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64",
        300,
        300,
      );
    });

  handleViewFile = (base64String, fileName) => {
    const mimeType = base64String.split(";")[0].split(":")[1];
    const byteCharacters = atob(base64String.split(",")[1]);
    const byteNumbers = Array.from(byteCharacters).map((char) =>
      char.charCodeAt(0),
    );
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    const fileURL = URL.createObjectURL(blob);

    if (mimeType.startsWith("image/") || mimeType === "application/pdf") {
      const newTab = window.open(fileURL, "_blank", "noopener,noreferrer");
    } else {
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = fileName;
      link.click();
    }

    setTimeout(() => URL.revokeObjectURL(fileURL), 500);
  };

  handleCameraCapture = async (base64Image) => {
    this.setState({
      documentFile: {
        FilePath: base64Image,
        FileName: "camera-capture.jpg",
        FileType: "jpeg",
      },
      showCameraModal: false,
      showRaiseModal: true,
    });
  };

  handleRaiseManualForm = () => {
    const { selectedRecord, documentFile } = this.state;

    if (!documentFile.FilePath || documentFile.FilePath.trim() === "") {
      toastError("Please upload a file");
      return;
    }

    const documentData = [
      {
        DocumentName: documentFile.FileName,
        FileName: documentFile.FileName,
        FilePath: documentFile.FilePath,
        FileType: documentFile.FileType,
        ActionID: 1,
      },
    ];

    this.setState({ isLoading: true });
    this.props
      .raiseManualForm_action(
        selectedRecord.ManualFormID,
        selectedRecord.RecordID,
        documentData,
      )
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("Manual form raised successfully!");
          this.closeModals();
        } else {
          toastError(data.msg);
        }
        this.setState({ isLoading: false });
      })
      .catch((err) => {
        toastError("Something went wrong!");
        this.setState({ isLoading: false });
      });
  };

  handleExport = (records) => {
    const headers = [
      "Application Registration No",
      "Confirm Date",
      "Company Name",
      "Person Name",
      "Email",
      "Mobile",
      "Country",
      "State",
      "City",
      "Primary Chapters",
      "Hall",
      "Stall No",
    ];

    const rows = records.map((data) => [
      data.ExhRegistrationNo || "",
      data.ConfirmedDate || "",
      data.CompanyName || "",
      data.name || "",
      data.Email || "",
      data.MobileNo || "",
      data.CountryName || "",
      data.StateName || "",
      data.CityName || "",
      data["PRIMARY CHAPTER"] || "",
      data.HallName || "",
      data.StallName || "",
    ]);

    const csvContent = [headers, ...rows]
      .map((row) =>
        row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(",")
      )
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "exhibitor_list.csv";
    link.click();
    URL.revokeObjectURL(url);
  };

  handleMarkPaid = () => {
    const { selectedRecord } = this.state;

    this.setState({ isLoading: true });
    this.props
      .markManualFormInvoicePaid_action(
        selectedRecord.ManualFormID,
        selectedRecord.RecordID,
        true,
      )
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("Manual form marked as paid successfully!");
          this.closeModals();
        } else {
          toastError(data.msg);
        }
        this.setState({ isLoading: false });
      })
      .catch((err) => {
        toastError("Something went wrong!");
        this.setState({ isLoading: false });
      });
  };

  onViewClickStallDesign(id) {
    sessionStorage.setItem('ExhRegistrationIDSS', id.ExhRegistrationID)
    this.setState({
      isViewModalOpen: true,
      selectedId: id,
    });
  }

  render() {
    const {
      isLoading,
      ExhibitionID,
      CompanyName,
      vendorServiceList,
      PersonName,
      ServiceID,
      currentPage,
      vendorRegistrationList,
      exhibitionList,
      serviceTypeList,
      orderStatusList,
      dashboardData, vendorColumnConfigurationList
    } = this.state;

    const serviceList = dashboardData?.serviceList || [];
    const hasOnlyService32 =
      serviceList.length === 1 && serviceList[0]?.ServiceID === 32;

    console.log(
      "serviceList:",
      serviceList,
      "hasOnlyService32:",
      vendorColumnConfigurationList,
    );

    if (hasOnlyService32) {
      return (
        <>
          <ToastContainer />
          {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
            <ExhibitorHeader />
          ) : (
            <HeaderWithLogo />
          )}
          <div class="main-content vendor-top-space">
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
              <ExhibitorDrawer />
            ) : (JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
              7 || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 17) ? (
              <VendorDrawer />
            ) : (
              <AdminDrawer />
            )}
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "60vh" }}
            >
              <div className="text-center">
                <h4>This page is not applicable for you</h4>
              </div>
            </div>
          </div>
        </>
      );
    }

    // console.log(vendorServiceList)
    var vendorServiceListArr = [];
    vendorServiceList.length > 0 &&
      vendorServiceList.forEach((item) => {
        for (var i = 0; i < serviceTypeList.length; i++) {
          if (serviceTypeList[i].ServiceID == item.ServiceID) {
            vendorServiceListArr.push(serviceTypeList[i]);
            break;
          }
        }
      });

    // Client-side filtering - filter data locally, applied only on Search button click
    const { ExhRegistrationFilter, CompanyNameFilter, PersonNameFilter, countryList, CountryIDs, exhibitorTypeList, ExhibitorTypeID,
      boothTypeList, BoothTypeID,
      appliedExhRegistrationFilter, appliedCompanyNameFilter, appliedPersonNameFilter, appliedCountryIDs, appliedExhibitorTypeID, appliedBoothTypeID } = this.state;
    let filteredRecords = vendorRegistrationList;

    if (appliedExhRegistrationFilter || appliedCompanyNameFilter || appliedPersonNameFilter || appliedCountryIDs.length > 0 || appliedExhibitorTypeID || appliedBoothTypeID) {
      const regNoFilter = (appliedExhRegistrationFilter || '').toLowerCase();
      const companyFilter = (appliedCompanyNameFilter || '').toLowerCase();
      const personFilter = (appliedPersonNameFilter || '').toLowerCase();

      filteredRecords = (vendorRegistrationList || []).filter(record => {
        const regNo = (record.ExhRegistrationNo || '').toLowerCase();
        const company = (record.CompanyName || '').toLowerCase();
        const person = (record.name || '').toLowerCase();
        const selectedCountryNames = appliedCountryIDs.map((code) => {
          const c = countryList.find((x) => x.Code === code);
          return c ? (c.Description || '').trim().toLowerCase() : '';
        });
        const countryMatch = appliedCountryIDs.length === 0 || selectedCountryNames.includes((record.CountryName || '').trim().toLowerCase());
        const selectedType = appliedExhibitorTypeID
          ? (exhibitorTypeList.find((t) => String(t.ID) === String(appliedExhibitorTypeID))?.ExhibitorType || '').toLowerCase()
          : '';
        const isDomestic = selectedType.includes('national') && !selectedType.includes('international');
        const isInternational = selectedType.includes('international');
        const isIndiaRecord = (record.CountryName || '').trim().toLowerCase().includes('india');
        const exhibitorTypeMatch = !appliedExhibitorTypeID ||
          (isDomestic && isIndiaRecord) ||
          (isInternational && !isIndiaRecord) ||
          (!isDomestic && !isInternational && String(record.ExhibitorTypeID) === String(appliedExhibitorTypeID));
        const boothTypeMatch = !appliedBoothTypeID || (record.StallTypeName || '').toLowerCase() === (boothTypeList.find(b => String(b.Code) === String(appliedBoothTypeID))?.Description || '').toLowerCase();

        return (
          (regNoFilter === '' || regNo.includes(regNoFilter)) &&
          (companyFilter === '' || company.includes(companyFilter)) &&
          (personFilter === '' || person.includes(personFilter)) &&
          countryMatch &&
          exhibitorTypeMatch &&
          boothTypeMatch
        );
      });
    }

    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = Array.isArray(filteredRecords)
      ? filteredRecords.slice(indexOfFirstRecord, indexOfLastRecord)
      : [];
    const nPages = Math.ceil(
      (filteredRecords?.length || 0) / recordsPerPage,
    );

    console.log("currentRecords", currentRecords);
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {(JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID === 7 || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 17) &&
          this.state.showVideoModal && (
            <div
              className="modal show d-block"
              style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
              onClick={() => this.setState({ showVideoModal: false })}
            >
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Order</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => this.setState({ showVideoModal: false })}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <video controls autoPlay style={{ width: "100%" }}>
                      <source src="/assets/VendorOrder.mp4" type="video/mp4" />
                    </video>
                  </div>
                </div>
              </div>
            </div>
          )}
        {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
          <ExhibitorHeader />
        ) : (
          <HeaderWithLogo />
        )}
        <div class="main-content vendor-top-space">
          {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
            <ExhibitorDrawer />
          ) : (JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 17) ? (
            <VendorDrawer />
          ) : (
            <AdminDrawer />
          )}
          {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
            <ExhibitorTopMenu />
          ) : null}
          {(JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID === 7 || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 17) && (
            <div className="d-flex justify-content-end px-2 pt-3 text-aqua">
              {/* <span
                onClick={() => this.setState({ showVideoModal: true })}
                style={{
                  cursor: "pointer",
                  color: "#3dbca7",
                  fontSize: "16px",
                  marginLeft: "auto",
                }}
              >
                <i className="bi bi-play-circle-fill me-2"></i>User Manual
              </span> */}
            </div>
          )}
          {/* <div class="row">
                        <div class="step-name">
                            <p>Service Partner Registration List</p>
                        </div>
                    </div> */}

          <div className="row m-0  px-0">
            <div className="col-xl-3 col-lg-3 col-md-6 mb-3">
              <label>Application Registration No</label>
              <input
                type="text"
                className="form-control"
                value={this.state.ExhRegistrationFilter}
                onChange={(e) =>
                  this.setState({ ExhRegistrationFilter: e.target.value })
                }
                placeholder="Search ExhRegistrationNo"
              />
            </div>
            <div className="col-xl-3 col-lg-3 col-md-6 mb-3">
              <label>Company Name</label>
              <input
                type="text"
                className="form-control"
                value={this.state.CompanyNameFilter}
                onChange={(e) =>
                  this.setState({ CompanyNameFilter: e.target.value })
                }
                placeholder="Search Company Name"
              />
            </div>
            <div className="col-xl-3 col-lg-3 col-md-6 mb-3">
              <label>Person Name</label>
              <input
                type="text"
                className="form-control"
                value={this.state.PersonNameFilter}
                onChange={(e) =>
                  this.setState({ PersonNameFilter: e.target.value })
                }
                placeholder="Search Person Name"
              />
            </div>
            <div className="col-xl-3 col-lg-3 col-md-6 mb-3">
              <label>Exhibitor Type</label>
              <select
                className="form-control"
                value={ExhibitorTypeID}
                onChange={(e) => this.setState({ ExhibitorTypeID: e.target.value, currentPage: 1 })}
              >
                <option value="">Select</option>
                {exhibitorTypeList.length > 0 &&
                  exhibitorTypeList.map((data) => (
                    <option key={data.ID} value={data.ID}>
                      {data.ExhibitorType}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-6 mb-3">
              <label>Booth Type</label>
              <select
                className="form-control"
                value={BoothTypeID}
                onChange={(e) => this.setState({ BoothTypeID: e.target.value, currentPage: 1 })}
              >
                <option value="">Select</option>
                {boothTypeList.length > 0 &&
                  boothTypeList.map((data) => (
                    <option key={data.Code} value={data.Code}>
                      {data.Description}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-6 mb-3">
              <label>Country</label>
              <select
                className="form-control"
                value={CountryIDs.length > 0 ? CountryIDs[0] : ""}
                onChange={(e) =>
                  this.setState({
                    CountryIDs: e.target.value ? [e.target.value] : [],
                    currentPage: 1,
                  })
                }
              >
                <option value="">Select</option>
                {countryList.length > 0 &&
                  countryList.map((data) => (
                    <option key={data.Code} value={data.Code}>
                      {data.Description}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-6 mb-3">
              <label>Service</label>
              <select
                className="form-control"
                value={this.state.selectedServiceId || ""}
                onChange={(e) =>
                  this.setState(
                    {
                      selectedServiceId: e.target.value || null,
                      currentPage: 1,
                    },
                    () => {
                      this.getVendorExhibitorList();
                    }
                  )
                }
              >
                <option value="">Select</option>
                {this.state.serviceTypeList &&
                  this.state.serviceTypeList.map((c) => (
                    <option key={c.ServiceID} value={c.ServiceID}>
                      {c.DisplayName || c.Name}
                    </option>
                  ))}
              </select>
            </div>
            <div className="col-xl-3 col-lg-3 col-md-6 mb-3 d-flex align-items-end gap-2">
              <button
                type="button"
                className="btn btn-aqua"
                style={{ height: "38px", minWidth: "75px" }}
                onClick={() => {
                  this.setState({
                    appliedExhRegistrationFilter: ExhRegistrationFilter,
                    appliedCompanyNameFilter: CompanyNameFilter,
                    appliedPersonNameFilter: PersonNameFilter,
                    appliedCountryIDs: [...CountryIDs],
                    appliedExhibitorTypeID: ExhibitorTypeID,
                    appliedBoothTypeID: BoothTypeID,
                    currentPage: 1,
                  });
                }}
              >
                Search
              </button>
              <button
                type="button"
                className="btn btn-gray"
                style={{ height: "38px", minWidth: "75px" }}
                onClick={() => {
                  this.setState(
                    {
                      ExhRegistrationFilter: "",
                      CompanyNameFilter: "",
                      PersonNameFilter: "",
                      CountryIDs: [],
                      ExhibitorTypeID: "",
                      BoothTypeID: "",
                      appliedExhRegistrationFilter: "",
                      appliedCompanyNameFilter: "",
                      appliedPersonNameFilter: "",
                      appliedCountryIDs: [],
                      appliedExhibitorTypeID: "",
                      appliedBoothTypeID: "",
                      currentPage: 1,
                    },
                    () => this.getVendorExhibitorList()
                  );
                }}
              >
                Clear
              </button>
            </div>
            {/* <div className="row mt-3"> */}
            {/* <div className="col-md-3 mt-3 d-flex justify-content-end">
              <div
                className=" mb-1"
                role="group"
                aria-label="Basic example"
                style={{ float: "left" }}
              >
                <button
                  type="button"
                  className="btn btn-aqua mx-2"
                  onClick={(e) => this.setState({ currentPage: 1 })}
                >
                  Search
                </button>
                <button
                  type="button"
                  className="btn btn-gray mx-2"
                  onClick={(e) => {
                    this.setState({ 
                      ExhRegistrationFilter: '',
                      CompanyNameFilter: '',
                      PersonNameFilter: '',
                      currentPage: 1 
                    });
                  }}
                >
                  Clear
                </button>
              </div>
              {currentRecords.some(
                (data) =>
                  data.isITMEBilling === false &&
                  data.optionForBillRaised === true,
              ) && (
                <div
                  className="d-flex flex-column ms-3"
                  style={{ fontSize: "13px" }}
                >
                  <span className="mb-1">
                    <i
                      className="fa fa-file-text"
                      style={{ color: "#6c757d", marginRight: "5px" }}
                    ></i>
                    <span className="me-1">Upload Invoice</span>
                    <i
                      className="fa fa-info-circle"
                      style={{ color: "#6c757d", cursor: "pointer" }}
                      title="Upload invoice document directly to exhibitor"
                    ></i>
                  </span>
                  <span>
                    <i
                      className="fa fa-check-circle"
                      style={{ color: "#28a745", marginRight: "5px" }}
                    ></i>
                    <span className="me-1">Mark Payment</span>
                    <i
                      className="fa fa-info-circle"
                      style={{ color: "#6c757d", cursor: "pointer" }}
                      title="Mark the invoice as paid after payment confirmation"
                    ></i>
                  </span>
                </div>
              )}
            </div> */}
            {/* </div> */}
          </div>

          <div className="row m-0 px-0">
            <div className="col-12">
              <div
                className="table-responsive sticky-table-wrapper mb-2"
                style={{ maxHeight: "calc(100vh - 310px)", overflowY: "auto" }}
              >
                {vendorColumnConfigurationList.length > 0 ? <table className="table sticky-table border text-nowrap text-md-nowrap table-bordered mb-0">
                  <thead className="table-light">
                    <tr>
                      {vendorColumnConfigurationList.includes(1) && <th>Application Registration No</th>}
                      {vendorColumnConfigurationList.includes(2) && <th>Confirm Date</th>}
                      {vendorColumnConfigurationList.includes(3) && <th>Company Name</th>}
                      {vendorColumnConfigurationList.includes(4) && <th>Person Name</th>}
                      {vendorColumnConfigurationList.includes(5) && <th>Email</th>}
                      {vendorColumnConfigurationList.includes(6) && <th>Mobile</th>}
                      {vendorColumnConfigurationList.includes(7) && <th>Country</th>}
                      {vendorColumnConfigurationList.includes(8) && <th>State</th>}
                      {vendorColumnConfigurationList.includes(9) && <th>City</th>}
                      {vendorColumnConfigurationList.includes(10) && <th>Primary Chapters</th>}
                      {vendorColumnConfigurationList.includes(11) && <th>Hall</th>}
                      {vendorColumnConfigurationList.includes(14) && <th>Stall No</th>}
                      {vendorColumnConfigurationList.includes(12) && <th>Booth Type</th>}
                      {vendorColumnConfigurationList.includes(13) && <th>View Stall Design</th>}
                      {/* <th>Action</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {currentRecords.length > 0 && currentRecords != null ? (
                      currentRecords.map((data, i) => (
                        <tr style={{ cursor: "pointer" }} key={i}>
                          {vendorColumnConfigurationList.includes(1) && < td > {data.ExhRegistrationNo || "-"}</td>}
                          {vendorColumnConfigurationList.includes(2) && < td > {data.ConfirmedDate || "-"}</td>}
                          {vendorColumnConfigurationList.includes(3) && < td > {data.CompanyName || "-"}</td>}
                          {vendorColumnConfigurationList.includes(4) && <td>{data.name || "-"}</td>}
                          {vendorColumnConfigurationList.includes(5) && <td>{data.Email || "-"}</td>}
                          {vendorColumnConfigurationList.includes(6) && <td>{data.MobileNo || "-"}</td>}
                          {vendorColumnConfigurationList.includes(7) && <td>{data.CountryName || "-"}</td>}
                          {vendorColumnConfigurationList.includes(8) && <td>{data.StateName || "-"}</td>}
                          {vendorColumnConfigurationList.includes(9) && <td>{data.CityName || "-"}</td>}
                          {vendorColumnConfigurationList.includes(10) && <td>{data["PRIMARY CHAPTER"] || '-'}</td>}
                          {vendorColumnConfigurationList.includes(11) && <td>{data.HallName || "-"}</td>}
                          {vendorColumnConfigurationList.includes(14) && <td>{data.StallName || "-"}</td>}
                          {vendorColumnConfigurationList.includes(12) && <td>{data.StallTypeName || "-"}</td>}
                          {vendorColumnConfigurationList.includes(13) && <td className="text-center">
                            {data.isStallDesignApproved ? <i
                              className="fa fa-eye grid-icon"
                              aria-hidden="true"
                              style={{
                                marginRight: "12px",
                                cursor: "pointer",
                                color: "#6c757d",
                              }}
                              title="View Details"
                              onClick={(e) => this.onViewClickStallDesign(data)}
                            /> : <></>}
                          </td>}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={13} className="text-center">
                          Record not found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table > : <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                  <tbody><tr> <td colSpan={12} className="text-center">
                    Record not found
                  </td> </tr>
                  </tbody>
                </table>
                }
              </div>
            </div>
          </div>
          {
            vendorColumnConfigurationList.length > 0 ? (
              <div className="table-pagination-footer">
                <div>
                  {filteredRecords.length > 0 ? (
                    <Pagination
                      nPages={nPages}
                      currentPage={currentPage}
                      setCurrentPage={this.updateItem}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                <div className="table-pagination-info">
                  <p>{`${currentPage} of ${nPages} pages`}</p>
                </div>
              </div>
            ) : <></>
          }
        </div >

        {/* Raise Manual Form Modal */}
        {
          this.state.showRaiseModal &&
          createPortal(
            <div
              className="modal fade show"
              style={{ display: "block", zIndex: 9999 }}
              onClick={this.closeModals}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Upload Invoice</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={this.closeModals}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label className="form-label">
                        Upload Invoice Document
                      </label>
                      {this.state.documentFile.FilePath ? (
                        <div className="d-flex align-items-center">
                          <span
                            className="grid-icon me-2"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.handleViewFile(
                                this.state.documentFile.FilePath,
                                this.state.documentFile.FileName,
                              )
                            }
                          >
                            <i className="fa fa-eye me-1"></i>
                            {this.state.documentFile.FileName}
                          </span>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-danger"
                            onClick={() =>
                              this.handleDocumentInput(null, "clear")
                            }
                          >
                            <i className="fa fa-times"></i> Remove
                          </button>
                        </div>
                      ) : (
                        <>
                          <input
                            type="file"
                            className="form-control mb-2"
                            accept="image/*,application/pdf"
                            onChange={(e) =>
                              this.handleDocumentInput(e, "file")
                            }
                          />
                          <div className="text-center">
                            <span className="text-muted">OR</span>
                          </div>
                          <button
                            type="button"
                            className="btn btn-aqua w-100 mt-2"
                            onClick={() =>
                              this.setState({
                                showCameraModal: true,
                                showRaiseModal: false,
                              })
                            }
                          >
                            <i className="fa fa-camera me-2"></i>
                            Capture from Camera
                          </button>
                        </>
                      )}
                    </div>

                    <div className="alert alert-warning d-flex align-items-center py-2 mb-2">
                      <i className="fa fa-exclamation-triangle me-2"></i>
                      <small>
                        All transactions will be between you and the exhibitor
                        only. The organizer is not involved.
                      </small>
                    </div>
                    <div className="text-center">
                      <small className="text-muted">
                        Supported formats: PDF, JPEG, PNG, JPG (Max size: 5MB)
                      </small>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-gray"
                      onClick={this.closeModals}
                    >
                      Back
                    </button>
                    <button
                      type="button"
                      className="btn btn-aqua"
                      onClick={this.handleRaiseManualForm}
                    >
                      Yes, Upload direct to exhibitor
                    </button>
                  </div>
                </div>
              </div>
            </div>,
            document.body,
          )
        }

        {/* Camera Capture Modal */}
        <ImageCapture
          isOpen={this.state.showCameraModal}
          onClose={() =>
            this.setState({ showCameraModal: false, showRaiseModal: true })
          }
          onCapture={this.handleCameraCapture}
          label="Capture Invoice Document"
        />

        {/* Mark Manual Form Invoice Paid Modal */}
        {
          this.state.showMarkPaidModal &&
          createPortal(
            <div
              className="modal fade show"
              style={{ display: "block", zIndex: 9999 }}
              onClick={this.closeModals}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title text-aqua">Confirm Payment</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={this.closeModals}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <p>
                      Are you sure you want to mark this manual form invoice as
                      paid?
                    </p>
                    {this.state.selectedRecord && (
                      <div className="">
                        <strong>Company:</strong>{" "}
                        {this.state.selectedRecord.CompanyName}
                        <br />
                        <strong>Service:</strong>{" "}
                        {this.state.selectedRecord.serviceprovided}
                      </div>
                    )}
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-gray"
                      onClick={this.closeModals}
                    >
                      No
                    </button>
                    <button
                      type="button"
                      className="btn btn-aqua"
                      onClick={this.handleMarkPaid}
                    >
                      Yes, Mark as Paid
                    </button>
                  </div>
                </div>
              </div>
            </div>,
            document.body,
          )
        }
        <Modal
          isOpen={this.state.isManualFormModalOpen}
          onRequestClose={() => this.setState({ isManualFormModalOpen: false })}
          shouldCloseOnEsc={true}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={false}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header  text-white">
                <h6 className="modal-title">Manual Form</h6>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() =>
                    this.setState({ isManualFormModalOpen: false })
                  }
                />
              </div>

              <div className="modal-body">
                {this.openModal(this.state.selectedServiceName)}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-gray"
                  onClick={() =>
                    this.setState({ isManualFormModalOpen: false })
                  }
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.isCompanyModalOpen}
          onRequestClose={() => this.setState({ isCompanyModalOpen: false })}
          shouldCloseOnEsc={true}
          shouldCloseOnOverlayClick={true}
          ariaHideApp={false}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header text-white">
                <h6 className="modal-title">Company Details</h6>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => this.setState({ isCompanyModalOpen: false })}
                />
              </div>

              <div className="modal-body">
                {this.state.selectedCompanyData &&
                  this.openModal(
                    this.state.selectedCompanyData.serviceprovided,
                  )}
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-gray"
                  onClick={() => this.setState({ isCompanyModalOpen: false })}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>
        <CommonModal
          isOpen={this.state.isViewModalOpen}
          componentName={"Stall design"}
          componentProps={{
            is_View: true,
            FormID: this.state.selectedId,
          }}
          onClose={() => this.setState({ isViewModalOpen: false })}
        />
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    fill_action,
    getVendorExhibitionList_action,
    getVendorExhibitorList_action,
    markOrderSeen_action,
    raiseManualForm_action,
    markManualFormInvoicePaid_action,
  })(VendorExhibitorList),
);
